module.exports = __webpack_public_path__ + "img/USD-icon.b99e64a.png";